import type { ExtractPreviewResponse } from '@/shared/hooks/api/userStandards'
import { StandardScopeExtractionPreviewContent } from './extraction-preview/StandardScopeExtractionPreviewContent'
import { StandardSignificantHazardsExtractionPreviewContent } from './extraction-preview/StandardSignificantHazardsExtractionPreviewContent'
import { StandardInformationForUseExtractionPreviewContent } from './extraction-preview/StandardInformationForUseExtractionPreviewContent'
import { StandardRiskReductionMeasuresExtractionPreviewContent } from './extraction-preview/StandardRiskReductionMeasuresExtractionPreviewContent'
import {
  ExtractionPreviewAllFailed,
  useExtractPreviewCopy,
} from './extraction-preview/standardExtractionPreviewShared'
import {
  getExtractionPreviewUiState,
  PREVIEW_TITLE_KEYS,
  type ExtractionPreviewUiState,
} from './extraction-preview/standardExtractionPreviewUiState'

export {
  PREVIEW_TITLE_KEYS,
  getExtractionPreviewUiState,
  type ExtractionPreviewUiState,
}

type StandardExtractionPreviewContentProps = {
  section: Parameters<typeof getExtractionPreviewUiState>[0]
  preview: ExtractPreviewResponse
  /** `source` shows verbatim extracted fields; `display` supports per-item language toggles. */
  contentVariant?: 'source' | 'display'
}

export function StandardExtractionPreviewContent({
  section,
  preview,
  contentVariant = 'display',
}: StandardExtractionPreviewContentProps) {
  const { translate, resolveReason } = useExtractPreviewCopy()
  const uiState = getExtractionPreviewUiState(section, preview, translate)

  if (uiState.allFailed) {
    return (
      <ExtractionPreviewAllFailed
        uiState={uiState}
        resolveReason={resolveReason}
        translate={translate}
      />
    )
  }

  const sectionProps = {
    preview,
    contentVariant,
    uiState,
    resolveReason,
    translate,
  }

  if (section === 'scope') {
    return <StandardScopeExtractionPreviewContent {...sectionProps} />
  }
  if (section === 'significantHazards') {
    return (
      <StandardSignificantHazardsExtractionPreviewContent {...sectionProps} />
    )
  }
  if (section === 'informationForUse') {
    return (
      <StandardInformationForUseExtractionPreviewContent {...sectionProps} />
    )
  }
  return (
    <StandardRiskReductionMeasuresExtractionPreviewContent {...sectionProps} />
  )
}
